import * as React from 'react';
import { BreadCrumbBase } from '../UI/BreadCrumbBase';
import { useNotificationBreadcrumbsStyles } from './useNotificationBreadcrumbsStyle';

export const InvoiceNotificationDetailsBreadcrumbs: React.FC<{
  invoiceNumber: string;
}> = ({ invoiceNumber }) => {
  const classes = useNotificationBreadcrumbsStyles();
  const items = [
    { label: 'Invoices', path: '/invoices' },
    { label: invoiceNumber },
  ];

  return (
    <div className={classes.breadcrumbs}>
      <BreadCrumbBase items={items} />
    </div>
  );
};
